import {Observable, throwError} from 'rxjs';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {Injectable} from '@angular/core';
import {catchError, tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    session_expired = false;

    constructor(private router: Router,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(
                succ => {
                },
                err => {
                    if (err.status === 401) {
                        console.log('Session has expired');
                        localStorage.setItem('customer_type', "guest");
                        this.router.navigateByUrl('/');

                        // if (this.isSessionExpiredFlag()) {
                        //     return;
                        // }
                        // this.setSessionExpiredFlag();
                        //  this.openNewGlobalNotificationDialog();
                        // this.router.navigateByUrl('/login');
                    } else if (err.status === 403) {
                        // this.router.navigateByUrl('/Forbidden');
                    } else if (err.status === 400) {
                        // this.router.navigateByUrl('/error404');
                    }
                }
            ));
    }

    // openNewGlobalNotificationDialog() {
    //
    //     const dialogRef = this.dialog.open(SessionExpiredPopupComponent, {
    //         width: '750px',
    //         data: {parent: this},
    //         disableClose: true
    //
    //     });
    //
    // }

    setSessionExpiredFlag() {
        this.session_expired = true;
    }

    isSessionExpiredFlag() {
        return this.session_expired;
    }

}
